import React, { createContext, useContext, useState } from "react";

const AppContext = createContext(null);

export const STYLE_OPTIONS = [
  { key: "illustration", label: "Illustration" },
  { key: "logo", label: "Logo" },
  { key: "game_sprite", label: "Sprite" },
  { key: "pixel_art", label: "Pixel Art" },
  { key: "icon", label: "Icon" },
  { key: "sticker", label: "Sticker" },
];

export const MODEL_TIERS = [
  { key: "fast", label: "Fast", credits: 1 },
  { key: "quality", label: "Quality", credits: 2 },
];

export const AppContextProvider = ({ children }) => {
  const [editor, setEditor] = useState(null);
  const [selectedStyle, setSelectedStyle] = useState("illustration");
  const [modelTier, setModelTier] = useState("quality");

  const value = {
    editor,
    setEditor,
    selectedStyle,
    setSelectedStyle,
    modelTier,
    setModelTier,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
}
